import { ConfirmDialog } from '@/components/common/ConfirmDialog';
import { useDeleteTemplate } from '@/hooks/useTemplates';

interface Props {
  templateId: string;
  name: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeleteTemplateDialog({ templateId, name, open, onOpenChange }: Props) {
  const { mutate: remove, isPending } = useDeleteTemplate();

  function handleConfirm() {
    remove(templateId, { onSuccess: () => onOpenChange(false) });
  }

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Excluir template"
      description={`Tem certeza que deseja excluir "${name}"? Esta ação não pode ser desfeita.`}
      confirmLabel="Excluir"
      variant="destructive"
      onConfirm={handleConfirm}
      loading={isPending}
    />
  );
}
